var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42056 8.71942C3.11133 6.07055 5.22187 4.04402 7.87215 3.48483L8.37858 3.37798C10.7672 2.87401 13.2328 2.87401 15.6214 3.37798L16.1278 3.48483C18.7781 4.04402 20.8887 6.07055 21.5794 8.71943C22.1402 10.8697 22.1402 13.1303 21.5794 15.2806C20.8887 17.9295 18.7781 19.956 16.1278 20.5152L15.6214 20.622C13.2328 21.126 10.7672 21.126 8.37858 20.622L7.87215 20.5152C5.22187 19.956 3.11133 17.9295 2.42056 15.2806C1.85981 13.1303 1.85981 10.8697 2.42056 8.71942Z",
    stroke: "#363853",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8L10 15L14 9L16 12H18",
    stroke: "#363853",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.2d138df8f017a0d50a4d2e9d7e3b766f.svg";
export { ForwardRef as ReactComponent };